import Vue from "vue";
// import httpService from '../../service'
import { utilsMixin } from "./utils";
import Globals from "../../globals.js";
import { i18n } from "../../../main.js";

// import Vuex from 'vuex'
import Toast from "vue-easy-toast";

Vue.use(Toast);

const d3 = require("d3");
export const planoMixin = {
    mixins: [utilsMixin],
    methods: {
        isNotSafari() {
            return Globals.getNavigator() !== Globals.NAVIGATOR_SAFARI;
        },
        includesPosition(array, object) {
            let res;
            for (let i = 0, l = array.length; i < l; i++) {
                res = array[i];
                if (res.x === object.x && res.y === object.y) return true;
            }

            return false;
        },
        includesPosition2(array, array2) {
            // let res
            // for (let i = 0, l = array.length; i < l; i++) {
            //     res = array[i]
            //     if (res.x === object.x && res.y === object.y) return true
            // }

            let result = array.filter(a => {
                let res = array2.filter(a2 => {
                    return a.x === a2.x && a.y === a2.y;
                });

                return res.length > 0;
            });

            return result.length > 0;
        },
        isGroupSelected() {
            let groupSelect = this.groupSelected;
            let modules = this.modulesSelected;
            let valid = true;
            if (modules.length === 1) {
                valid = true;
            } else {
                if (groupSelect !== null) {
                    let group;
                    for (let i = 0; i < modules.length; i++) {
                        group = this.getGroupByModule(d3.select(modules[i]).data()[0]);
                        if (group.id !== groupSelect.id) {
                            valid = false;
                            break;
                        }
                    }
                } else {
                    valid = false;
                }
            }
            if (valid === false) alert("Attention: On peut seulement dupliquer un groupe");
            return valid;
        },
        round(p, n) {
            return p % n < n / 2 ? p - (p % n) : p + n - (p % n);
        },
        /**
         *
         * @param positions
         * @return {Array} return les position valide pour un module coller
         */
        getPositionValid(positions) {
            let poss = [];
            let possTmp = [];
            let x1, x2, x3, x4, y1, y2, y3, y4;

            positions.forEach(position => {
                x1 = position.x;
                y1 = position.y - 1;
                x2 = position.x - 1;
                y2 = position.y;
                x3 = position.x;
                y3 = position.y + 1;
                x4 = position.x + 1;
                y4 = position.y;

                possTmp.push({ x: x1, y: y1 });
                possTmp.push({ x: x2, y: y2 });
                possTmp.push({ x: x3, y: y3 });
                possTmp.push({ x: x4, y: y4 });

                possTmp.forEach(posTmp => {
                    if (this.includesPosition(positions, posTmp) === false && this.includesPosition(poss, posTmp) === false) {
                        poss[poss.length] = posTmp;
                    }
                });
            });

            return poss;
        },

        canCreateGroup() {
            let modules = this.getDataModuleSelected();

            let positions = [];
            let position;
            let pos;
            modules.forEach(mod => {
                pos = this.getPosModule(mod);
                position = {
                    UUID: mod.UUID,
                    position: pos,
                    positionValid: this.getPositionValid(pos)
                };

                positions.push(position);
            });

            let groups = [];
            let modulesGroup;
            let group;
            positions.forEach(posi => {
                positions.forEach(posi2 => {
                    if (posi !== posi2) {
                        // console.log(posi)
                        if (this.includesPosition2(posi.positionValid, posi2.position)) {
                            if (groups.length === 0) {
                                modulesGroup = {
                                    modulesID: [],
                                    position: [],
                                    positionValid: []
                                };
                                modulesGroup.modulesID.push(posi.UUID);
                                modulesGroup.modulesID.push(posi2.UUID);
                                modulesGroup.position = posi.position.concat(posi2.position);
                                modulesGroup.positionValid = posi.positionValid.concat(posi2.positionValid);
                                groups.push(modulesGroup);
                            } else {
                                group = groups.find(g => {
                                    let res = g.modulesID.find(m => {
                                        return m === posi2.UUID || m === posi.UUID;
                                    });
                                    return res !== undefined;
                                });

                                if (group) {
                                    if (!group.modulesID.includes(posi2.UUID)) {
                                        group.modulesID.push(posi2.UUID);
                                        group.position = group.position.concat(posi2.position);
                                        group.positionValid = group.positionValid.concat(posi2.positionValid);
                                    }

                                    if (!group.modulesID.includes(posi.UUID)) {
                                        group.modulesID.push(posi.UUID);
                                        group.position = group.position.concat(posi.position);
                                        group.positionValid = group.positionValid.concat(posi.positionValid);
                                    }
                                } else {
                                    modulesGroup = {
                                        modulesID: [],
                                        position: [],
                                        positionValid: []
                                    };
                                    modulesGroup.modulesID.push(posi.UUID);
                                    modulesGroup.modulesID.push(posi2.UUID);
                                    modulesGroup.position = posi.position.concat(posi2.position);
                                    modulesGroup.positionValid = posi.positionValid.concat(posi2.positionValid);
                                    groups.push(modulesGroup);
                                }
                            }
                        }
                    }
                });
            });

            // console.log(groups, '====== groups =======')

            let gs = [];

            groups.forEach(gr => {
                gs = gs.concat(gr.modulesID);
            });
            // console.log(gs)
            if (groups.length === 0) {
                return false;
            } else if (gs.length !== modules.length) {
                return false;
            } else if (groups.length === 1) {
                return true;
            } else {
                return false;
            }
        },

        // canCreateGroup () {
        //     let modules = this.getDataModuleSelected()
        //
        //     // let module
        //     let data
        //     let poss = {}
        //     let possValid = []
        //     let pos
        //     let positions
        //     let positions2 = []
        //
        //     modules.sort((m1, m2) => {
        //         return m1.posX - m2.posX + m1.posY - m2.posY
        //     })
        //
        //     // console.log(modules)
        //
        //     let valid = true
        //     for (let i = 0; i < modules.length; i++) {
        //         data = modules[i]
        //         // data = d3.select(module).data()[0]
        //
        //         poss[data.UUID] = {
        //             positions: this.getPosModule(data),
        //             valid: false
        //         }
        //
        //         positions2.push(poss[data.UUID])
        //
        //         possValid[possValid.length] = {
        //             uuid: data.UUID,
        //             positions: this.getPositionValid(this.getPosModule(data))
        //         }
        //     }
        //     // let groupsPos = {}
        //     for (let i = 0; i < modules.length; i++) {
        //         data = modules[i]
        //         // data = d3.select(module).data()[0]
        //         pos = poss[data.UUID]
        //         // groupsPos[data.UUID] = []
        //         possValid.forEach((posValid) => {
        //             positions = posValid.positions
        //             positions.forEach((posi) => {
        //                 if (posi.uuid !== data.UUID) {
        //                     if (this.includesPosition(pos.positions, posi)) {
        //                         // groupsPos[data.UUID].push(posi)
        //                         pos.valid = true
        //                     }
        //                 }
        //             })
        //
        //         })
        //     }
        //
        //     let keys = Object.keys(poss)
        //     let key
        //     for (let i = 0; i < keys.length; i++) {
        //         key = keys[i]
        //         pos = poss[key]
        //         if (pos.valid === false) {
        //             valid = false
        //             break
        //         }
        //     }
        //
        //     if (valid) {
        //         // console.log(groupsPos)
        //         // let v
        //         // let posNext
        //         // let result = positions2.filter((pos, i) => {
        //         //     posNext = positions2[i + 1]
        //         //     // console.log(mod, posNext)
        //         //     // if (pos.)
        //         // })
        //         //
        //         // console.log(result, '=============================')
        //
        //     }
        //     return valid
        // },
        /**
         *
         * @param x
         * @param y
         * @return Node return le rectancle a la position de la souris
         */
        getRectByPos(x, y) {
            let rect = null;
            if (document.elementsFromPoint) {
                let elts = document.elementsFromPoint(x, y);
                let elt;
                for (let i = 0, l = elts.length; i < l; i++) {
                    elt = elts[i];
                    if (elt.id === "contentMenu" || elt.id === "scratchPad" || elt.id === "favorite") {
                        return null;
                    }
                }
                for (let i = 0, l = elts.length; i < l; i++) {
                    elt = elts[i];
                    if (elt.nodeName === "rect" && elt.getAttribute("class") === "rect-content-module") {
                        rect = elt;
                        break;
                    }
                }
            } else {
                if (
                    this.elementFromPoint("#contentMenu", x, y) ||
                    this.elementFromPoint("#scratchPad", x, y) ||
                    this.elementFromPoint("#favorite", x, y)
                ) {
                    return null;
                }
                rect = this.elementFromPoint(".rect-content-module", x, y);
            }
            return rect;
        },
        /**
         *
         * @param posX
         * @param posY
         * @return Node return le rectangle a la position ou il est du plano
         */
        getRectByPosition(posX, posY) {
            let rects = d3
                .select("#meubleInt")
                .selectAll(".rect-content-module")
                .nodes();
            let rect = null;
            let d;
            let res = null;

            for (let i = 0, l = rects.length; i < l; i++) {
                rect = rects[i];
                d = d3.select(rect).data()[0];
                if (d.posX === posX && d.posY === posY) {
                    res = rect;
                    break;
                }
            }
            return res;
        },
        getRectSegByPos(x, y) {
            let rect = null;
            if (document.elementsFromPoint) {
                let elts = document.elementsFromPoint(x, y);

                let elt;
                for (let i = 0, l = elts.length; i < l; i++) {
                    elt = elts[i];
                    if (elt.id === "contentMenu" || elt.id === "scratchPad" || elt.id === "favorite") {
                        return null;
                    }
                }
                for (let i = 0, l = elts.length; i < l; i++) {
                    elt = elts[i];
                    if (elt.nodeName === "rect" && elt.getAttribute("class") === "rect-grid-seg") {
                        rect = elt;
                        break;
                    }
                }
            } else {
                if (
                    this.elementFromPoint("#contentMenu", x, y) ||
                    this.elementFromPoint("#scratchPad", x, y) ||
                    this.elementFromPoint("#favorite", x, y)
                ) {
                    return null;
                }
                rect = this.elementFromPoint(".rect-grid-seg", x, y);
            }

            return rect;
        },
        getRectSegmentationPosition(posX, posY) {
            let rects = d3
                .select("#meubleInt")
                .selectAll("rect.rect-grid-seg")
                .nodes();
            let rect = null;
            let d;
            let res = null;

            for (let i = 0, l = rects.length; i < l; i++) {
                rect = rects[i];
                d = d3.select(rect).data()[0];
                if (d.posX === posX && d.posY === posY) {
                    res = rect;
                    break;
                }
            }
            return res;
        },
        /**
         * @param moduleData
         * @return retourne toute les positions x et y qui occupe
         */
        getPosModule(moduleData) {
            return this.getPositions(moduleData.posX, moduleData.posY, moduleData);
        },

        getPosAccessory(accessoryData) {
            return this.getPositions(accessoryData.posX, accessoryData.posY, accessoryData);
        },
        getPositions(posX, posY, dataMod) {
            let poss = [];
            let pos;
            for (let i = 0; i < dataMod.size.width; i++) {
                pos = {};
                pos.x = posX + i;

                for (let j = 0; j < dataMod.size.height; j++) {
                    if (j === 0) {
                        pos.y = posY + j;
                        poss[poss.length] = pos;
                    } else {
                        pos = {};
                        pos.x = posX + i;
                        pos.y = posY + j;
                        poss[poss.length] = pos;
                    }
                }
            }
            return poss;
        },
        hasModuleOutAtPos(posXNew, posYNew, moduleCurrent) {
            let posCurrent = this.getPositions(posXNew, posYNew, moduleCurrent);
            let rect, pos;
            // console.log(posCurrent)
            for (let i = 0, l = posCurrent.length; i < l; i++) {
                pos = posCurrent[i];
                rect = this.getRectByPosition(pos.x, pos.y);
                if (!rect) return true;
            }

            return false;
        },
        hasModuleAtPos(posXNew, posYNew, moduleCurrent) {
            let modules = this.getModules();
            let module;
            let moduleSelected = this.getDataModuleSelected();
            for (let i = 0, l = modules.length; i < l; i++) {
                module = modules[i];
                if (!moduleSelected.includes(module)) {
                    let posCurrent = this.getPositions(posXNew, posYNew, moduleCurrent);
                    let posOther = this.getPosModule(module);
                    let res;
                    let result = posCurrent.filter(pos => {
                        res = posOther.filter(posO => {
                            return pos.x === posO.x && pos.y === posO.y;
                        });
                        return res.length > 0;
                    });

                    if (result.length > 0) return true;
                }
            }

            return false;
        },

        hasModulesPos(posX, posY, modules) {
            // let modulesAll = this.getModules
            // console.log(modules)
            let module;
            for (let i = 0; i < modules.length; i++) {
                module = modules[i];
                if (this.hasModulePos(posX, posY, module, modules)) {
                    return true;
                }
            }

            return false;
        },
        hasModulePos(posX, posY, dataModCurrent, dataModsCurrent = null) {
            let modules = this.getModules();
            let data;
            let valid;
            // let dataCurrent = d3.select(moduleCurrent).data()[0]

            let possModCurrent = this.getPositions(posX, posY, dataModCurrent);
            let posModCurrent;
            let horiPitchRepeat = this.getMeuble.plano ? this.getMeuble.plano.steps[1].repeat : this.getMeuble.steps[1].repeat;
            let vertPitchRepeat = this.getMeuble.plano ? this.getMeuble.plano.steps[1].repeat : this.getMeuble.steps[0].repeat;
            // let posXtmp
            // let posYtmp
            let possMod;
            let posMod;
            for (let i = 0; i < modules.length; i++) {
                data = modules[i];
                if (dataModsCurrent !== null) {
                    valid = dataModsCurrent.includes(data) === false && dataModCurrent !== data;
                } else {
                    valid = dataModCurrent !== data;
                }

                if (valid) {
                    possMod = this.getPosModule(data);
                    // console.log(data, possMod)
                    if (data.type === dataModCurrent.type) {
                        for (let j = 0; j < possModCurrent.length; j++) {
                            posModCurrent = possModCurrent[j];
                            for (let k = 0; k < possMod.length; k++) {
                                posMod = possMod[k];
                                if (posModCurrent.x === posMod.x && posModCurrent.y === posMod.y) {
                                    alert("On ne peut pas mettre un module a cette position elle est déjà occupé");
                                    return true;
                                }
                            }
                        }
                    }
                }
            }

            for (let j = 0; j < possModCurrent.length; j++) {
                posModCurrent = possModCurrent[j];
                if (posModCurrent.x >= horiPitchRepeat || posModCurrent.y >= vertPitchRepeat) {
                    alert("Attention: le module sort du plano");
                    return true;
                }
            }
            return false;
        },
        hasAccessoryPos(posX, posY, dataAccessoryCurrent) {
            let accessories = this.getAccessories;
            // if (!accessories.includes(dataAccessoryCurrent)) {
            let accessory;
            let positions, position, positionCurrent;
            let possitionsCurrent = this.getPosAccessory(dataAccessoryCurrent);

            for (let i = 0; i < accessories.length; i++) {
                accessory = accessories[i];
                if (accessory.subtype === "31") continue;
                if (accessory !== dataAccessoryCurrent) {
                    positions = this.getPosAccessory(accessory);
                    for (let j = 0; j < possitionsCurrent.length; j++) {
                        positionCurrent = possitionsCurrent[j];
                        for (let k = 0; k < positions.length; k++) {
                            position = positions[k];
                            // if (possitionsCurrent)
                            if (position.x === positionCurrent.x && position.y === positionCurrent.y) {
                                alert("On ne peut pas mettre un accessoire a cette position elle est déjà occupé");
                                return true;
                            }
                        }
                    }
                }
            }
            // }

            return false;
        },
        getGroupById(id) {
            let groups = this.groups;
            // console.log(this.groups)
            let group;
            for (let i = 0, l = groups.length; i < l; i++) {
                group = groups[i];
                if (group.id === id) {
                    return group;
                }
            }
            return null;
        },
        addGroupAuto(moduleSvg, uuid = this.UUID()) {
            // if (this.getModules.includes(moduleSvg) === false) {
            //     this.addModule(moduleSvg)
            // }
            let dataModule = d3.select(moduleSvg).data()[0];
            let groupId = uuid;
            let groupExist = this.getGroupById(uuid);
            let group = {
                id: groupId,
                modules: []
            };

            if (groupExist !== null) {
                group = groupExist;
            }

            dataModule.groupId = groupId;
            d3.select(moduleSvg).datum(dataModule);
            group.modules.push(dataModule);
            if (groupExist === null) {
                this.groups.push(group);
            }

            return uuid;
        },
        getSizeContentModule() {
            // let dataPan = d3.select('#contentPlanoMain').data().length > 0 ? d3.select('#contentPlanoMain').data()[0] : null
            //
            // let transform = dataPan ? dataPan.transform : null
            // let k = transform ? transform.k : 1
            let rect = this.getRectByPosition(0, 0);
            let bbContentMod = rect.parentNode.getBBox();
            let g = d3.select("g#contentPlanoMain").node();
            let bb = g.getBoundingClientRect();
            // let bbPlano = d3.select('#contentPlanoMain').node().getBBox()
            let svgPlano = d3.select("svg#builder");
            let viewBox = svgPlano.attr("viewBox");
            let size = viewBox.split(" ");
            let widthViewBoxSvg = parseInt(size[2], 10);
            let heightViewBoxSvg = parseInt(size[3], 10);
            // let widthSvg = parseInt(svgPlano.attr('width'), 10)
            // let heightSvg = parseInt(svgPlano.attr('height'), 10)
            // svgPlano.node().clientWidth
            // svgPlano.node().clientHeight

            let width = bbContentMod.width * (bb.width / widthViewBoxSvg);
            let height = bbContentMod.height * (bb.height / heightViewBoxSvg);
            return { width: width, height: height };
        },
        getSizeContentSegmentation() {
            let rectSeg = d3.select("rect#segmentation");
            if (rectSeg.size() > 0) {
                let rect = this.getRectSegmentationPosition(0, 0);
                if (rect !== null) {
                    let rectData = d3.select(rect).data()[0];
                    let g = d3.select("g#contentPlanoMain").node();
                    let bb = g.getBoundingClientRect();

                    let svgPlano = d3.select("svg#builder");
                    let viewBox = svgPlano.attr("viewBox");
                    let size = viewBox.split(" ");
                    let widthViewBoxSvg = parseInt(size[2], 10);
                    let heightViewBoxSvg = parseInt(size[3], 10);

                    let width = parseInt(rectData.width, 10) * (bb.width / widthViewBoxSvg);
                    let height = parseInt(rectData.height, 10) * (bb.height / heightViewBoxSvg);
                    return { width: width, height: height };
                }
            }

            return null;
        },
        loadListnerModule(eltModule) {
            this.drag(d3.select(eltModule), this.dragStartSVG, this.dragSVG, this.dragEndSVG);
            // d3.select(eltModule).on('contextmenu', (d, i, cmps) => {
            //
            //     this.selectionModule(d, i, cmps)
            // })
        },
        drag(elt, start = null, dragged = null, end = null) {
            let isMobile = Globals.isMobile();
            // let isSafari = Globals.getNavigator() === Globals.NAVIGATOR_SAFARI
            if (isMobile === false) {
                let drag = d3
                    .drag()
                    .on("start", start === null ? this.started : start)
                    .on("drag", dragged === null ? this.dragged : dragged)
                    .on("end", end === null ? this.ended : end);
                elt.call(drag);
            }
        },
        started(d, i, cmps) {
            let img = cmps[i];
            d3.select(img).classed("dragging", true);
            // .attr('x', )
            img.style.left = d.x + "px";
            img.style.top = d.y + "px";
        },
        dragged(data, i, cmps) {
            // let sizeContentMod = this.getSizeContentModule()
            // let width = sizeContentMod.width
            // let height = sizeContentMod.height
            // let r = this.getMeuble.steps[1].length
            let img = cmps[i];

            let x = 0;
            let y = 0;
            x = d3.event.sourceEvent.clientX;
            y = d3.event.sourceEvent.clientY;

            data.x = x - data.diffX;
            data.y = y - data.diffY;

            img.style.left = data.x + "px";
            img.style.top = data.y + "px";
        },
        endedSeg(d, i, cmps) {
            let img = cmps[i];
            let idModule = img.id.split("item_")[1];
            let uuid = "elt_" + this.UUID();
            let event = d3.event;
            let dataImg = d;
            let type = img.getAttribute("component_type");
            let subtype = img.getAttribute("component_subtype");
            let rect = this.getRectSegByPos(event.sourceEvent.pageX, event.sourceEvent.pageY);
            if (rect !== null) {
                // console.log(d)
                // console.log(d.item)
                let data = d3.select(rect).data()[0];
                let accessoryColor = img.getAttribute("accessory_color") ? img.getAttribute("accessory_color") : null;
                let dataMod = {
                    x: data.x,
                    y: data.y,
                    type: type,
                    subtype: subtype,
                    posX: data.posX,
                    posY: data.posY,
                    size: dataImg.size,
                    selected: false,
                    id: idModule,
                    UUID: uuid,
                    posInit: { posX: 0, posY: 0 },
                    text: Globals.getValueObject(d.item, "terms.nickname", null)
                };
                dataMod.color = accessoryColor;
                // console.log(dataMod)
                let widthMod = parseInt(rect.getAttribute("width"), 10) * dataImg.size.width;
                let heightMod = parseInt(rect.getAttribute("height"), 10) * dataImg.size.height;
                let g = d3.select("#meubleInt").append("g");
                // console.log(dataMod.text.fr.value)
                let frame = g
                    .append("rect")
                    .raise()
                    .data([dataMod])
                    .attr("width", widthMod)
                    .attr("height", heightMod)
                    .attr("stroke", accessoryColor)
                    .attr("stroke-width", 8)
                    .attr("fill", accessoryColor)
                    .attr("id", uuid)
                    .attr("x", data.x)
                    .attr("y", data.y)
                    .attr("class", "accessory-segmentation");
                let text = g
                    .append("text")
                    .raise()
                    .attr("class", "text-segmentation")
                    .text(this.getTranslate(dataMod.text))
                    .attr("x", data.x)
                    .attr("y", data.y)
                    // .attr('width', widthMod)
                    // .attr('height', heightMod)
                    .attr("dy", 40)
                    .attr("fill", "white")
                    .style("font-size", heightMod);

                let bbText = text.node().getBBox();
                let dx = widthMod / 2 - bbText.width / 2;
                text.attr("dx", dx);
                this.addAccessory(dataMod);
                this.drag(frame, this.dragStartAccessory, this.dragAccessory, this.dragEndAccessory);
                this.setUpdatePlano(false);
            }
            img.parentNode.removeChild(img);
        },
        ended(d, i, cmps) {
            let img = cmps[i];
            let idModule = img.id.split("item_")[1];
            let uuid = "elt_" + this.UUID();
            let groupId;
            // let copySvg = null
            let event = d3.event;
            let dataImg = d3.select(img).data()[0];
            let type = img.getAttribute("component_type");
            let subtype = img.getAttribute("component_subtype");
            let rect = this.getRectByPos(event.sourceEvent.pageX, event.sourceEvent.pageY);

            if (rect !== null) {
                let data = d3.select(rect).data()[0];
                // creer si il n
                dataImg.posX = data.posX;
                dataImg.posY = data.posY;
                if (this.hasModulePos(data.posX, data.posY, dataImg) === false) {
                    let accessoryColor = img.getAttribute("accessory_color") ? img.getAttribute("accessory_color") : null;
                    let dataMod = {
                        x: data.x,
                        y: data.y,
                        type: type,
                        subtype: subtype,
                        posX: data.posX,
                        posY: data.posY,
                        size: dataImg.size,
                        selected: false,
                        id: idModule,
                        UUID: uuid,
                        posInit: { posX: 0, posY: 0 },
                        groupId: null,
                        visual: null
                    };

                    if (type === "module") {
                        dataMod.src = img.getAttribute("srcmodule");
                        dataMod.srcreal = img.getAttribute("srcreal");
                        dataMod.timestamp = parseInt(img.getAttribute("timestamp"), 10);
                        let nicknameTmp = d.item.terms.nickname;
                        let nickname = {};
                        if (nicknameTmp) {
                            let langs = Object.keys(nicknameTmp);
                            nickname = {};
                            langs.forEach(lang => {
                                nickname[lang] = nicknameTmp[lang].value;
                            });
                        } else {
                            nickname["fr"] = d.item.nickname;
                        }
                        // console.log('modif')
                        dataMod.config = {
                            texts: {
                                name: nickname,
                                refs: {
                                    DIAM: Globals.getValueObject(d.item, "infosArticle.diam_ref1.componentProperty.value", ""),
                                    client: Globals.getValueObject(d.item, "infosArticle.client_ref1.componentProperty.value", "")
                                }
                            }
                        };
                        if (d.item.config) {
                            // console.log(d.item.config, '====================================================== item')
                            if (d.item.config.groups instanceof Array) {
                                dataMod.config.groups = this.assign(d.item.config.groups);
                            }

                            if (d.item.config.tickets instanceof Array) {
                                dataMod.config.tickets = this.assign(d.item.config.tickets);
                            }
                        }
                    }
                    if (type === "accessory" && accessoryColor !== null) {
                        dataMod.color = accessoryColor;
                    }
                    let widthMod = parseInt(rect.getAttribute("width"), 10) * dataImg.size.width;
                    let heightMod = parseInt(rect.getAttribute("height"), 10) * dataImg.size.height;

                    if (type === "module") {
                        // console.log(dataMod, 'data module ====')
                        this.createModule(dataMod).then(res => {
                            if (res) {
                                let gContentModule = d3
                                    .select("#meubleInt")
                                    .append("g")
                                    .raise();
                                gContentModule.raise();
                                gContentModule.node().append(res.elt);
                                this.loadConfigModule(res.elt, res.module, false);
                                groupId = this.addGroupAuto(res.elt);
                                gContentModule.data([
                                    {
                                        groupId: groupId,
                                        selected: false
                                    }
                                ]);
                                this.loadListnerModule(res.elt);
                                // this.drag(d3.select(res.elt), this.dragStartSVG, this.dragSVG, this.dragEndSVG)
                                d3.select("#meubleInt")
                                    .selectAll("rect.accessory-frame")
                                    .raise();
                                return true;
                            } else {
                                return false;
                            } //
                        });
                    } else {
                        if (this.hasAccessoryPos(data.posX, data.posY, dataMod) === false) {
                            let frame = d3
                                .select("#meubleInt")
                                // .append('g')
                                // .raise()
                                .append("rect")
                                .raise()
                                .data([dataMod])
                                .attr("width", widthMod)
                                .attr("height", heightMod)
                                .attr("stroke", accessoryColor)
                                .attr("stroke-width", 10)
                                .attr("fill-opacity", 0)
                                .attr("id", uuid)
                                .attr("x", data.x)
                                .attr("y", data.y)
                                .attr("class", "accessory-frame");
                            this.addAccessory(dataMod);
                            this.drag(frame, this.dragStartAccessory, this.dragAccessory, this.dragEndAccessory);
                        }
                    }
                    this.setUpdatePlano(false);
                }
                d3.select("#meubleInt")
                    .selectAll("rect.accessory-frame")
                    .raise();
            }
            img.parentNode.removeChild(img);
        },
        dragStartAccessory(d, i, cmps) {
            this.clickSelectionAccessory(d, i, cmps);
            let isSegmentation = d.subtype === "31";
            let rect = isSegmentation
                ? this.getRectSegByPos(d3.event.sourceEvent.pageX, d3.event.sourceEvent.pageY)
                : this.getRectByPos(d3.event.sourceEvent.pageX, d3.event.sourceEvent.pageY);
            let dataRect = d3.select(rect).data()[0];
            let posXOrigin = d.posX - dataRect.posX;
            let posYOrigin = d.posY - dataRect.posY;
            let origin = { posX: posXOrigin, posY: posYOrigin };
            if (isSegmentation) d.mouseY = d3.event.sourceEvent.pageY;
            d.posInit = origin;
            let accessoiry = cmps[i];
            // .classed('dragging', true)
            let accessoiryD3 = d3.select(accessoiry);
            accessoiryD3.raise();

            accessoiryD3
                .attr("x", (data, i, cmps) => {
                    return data.x;
                })
                .attr("y", data => {
                    return data.y;
                });
        },
        dragAccessory(d, i, cmps) {
            let x = d3.event.x;
            let y = d3.event.y;
            let accessory = cmps[i];
            let g = accessory.parentNode;
            d3.select(cmps[i])
                .attr("x", data => {
                    if (data.subtype === "31")
                        d3.select(g)
                            .select("text")
                            .attr("x", x);
                    return x;
                })
                .attr("y", data => {
                    if (data.subtype === "31") {
                        return data.y;
                    } else {
                        return y;
                    }
                });
        },
        dragEndAccessory(data, i, cmps) {
            let isSegmentation = data.subtype === "31";
            let rect = isSegmentation
                ? this.getRectSegByPos(d3.event.sourceEvent.pageX, data.mouseY)
                : this.getRectByPos(d3.event.sourceEvent.pageX, d3.event.sourceEvent.pageY);
            if (isSegmentation) delete data.mouseY;
            let frame = cmps[i];
            let frameD3 = d3.select(frame).raise();
            let valid = true;

            if (rect !== null) {
                let dataRect = d3.select(rect).data()[0];
                let rectAlt = isSegmentation
                    ? this.getRectSegmentationPosition(dataRect.posX + data.posInit.posX, dataRect.posY + data.posInit.posY)
                    : this.getRectByPosition(dataRect.posX + data.posInit.posX, dataRect.posY + data.posInit.posY);
                let dataRectAlt = d3.select(rectAlt).data()[0];
                // this.hasAccessoryPos(dataRectAlt.posX, dataRectAlt.posY, data)
                // if (this.hasAccessoryPos(dataRectAlt.posX, dataRectAlt.posY, data) === false) {
                frameD3
                    .attr("x", d => {
                        d.x = dataRectAlt.x;
                        d.posX = dataRectAlt.posX;
                        if (isSegmentation) {
                            let g = frame.parentNode;
                            d3.select(g)
                                .select("text")
                                .raise()
                                .attr("x", dataRectAlt.x);
                        }
                        return d.x;
                    })
                    .attr("y", d => {
                        if (!isSegmentation) {
                            d.y = dataRectAlt.y;
                            d.posY = dataRectAlt.posY;
                        }
                        return d.y;
                    });
                // }
            } else {
                valid = false;
            }

            if (valid === false) {
                frameD3
                    .attr("x", d => {
                        if (isSegmentation) {
                            let g = frame.parentNode;
                            d3.select(g)
                                .select("text")
                                .raise()
                                .attr("x", d.x);
                        }
                        return d.x;
                    })
                    .attr("y", d => {
                        return d.y;
                    });
            }
        },
        dragEndFav(data, i, cmps, objectScratchpad) {
            let svg = cmps[i];
            let rect = this.getRectByPos(d3.event.sourceEvent.pageX, d3.event.sourceEvent.pageY);
            let valid = true;
            if (rect !== null) {
                let groupId = this.UUID();
                let dataRect = d3.select(rect).data()[0];
                let posX;
                let posY;
                let rectAlt;
                let dataRectAlt;
                // console.log(objectScratchpad)
                // let modules = d3.select(svg).select('g').selectAll('svg.module_snap')
                let gContentModule = d3
                    .select("#meubleInt")
                    .append("g")
                    .raise();
                gContentModule.data([
                    {
                        groupId: groupId,
                        selected: false
                    }
                ]);
                let uuidMod;
                let modules = objectScratchpad.modules;
                modules.forEach(module => {
                    if (valid === false) return false;
                    let d = module.data;
                    let resX = d.posX;
                    let resY = d.posY;
                    posX = resX + dataRect.posX;
                    posY = resY + dataRect.posY;
                    rectAlt = this.getRectByPosition(posX, posY);
                    dataRectAlt = d3.select(rectAlt).data()[0];
                    if (rectAlt === null || this.hasModuleAtPos(dataRectAlt.posX, dataRectAlt.posY, d) === true) {
                        valid = false;
                        return false;
                    }
                });

                if (valid) {
                    modules.forEach(module => {
                        let dataCop = this.assign(module.data);
                        uuidMod = "elt_" + this.UUID();
                        let resX = dataCop.posX;
                        let resY = dataCop.posY;
                        posX = resX + dataRect.posX;
                        posY = resY + dataRect.posY;
                        dataCop.groupId = null;
                        dataCop.selected = false;
                        dataCop.UUID = uuidMod;
                        rectAlt = this.getRectByPosition(posX, posY);
                        dataRectAlt = d3.select(rectAlt).data()[0];

                        dataCop.x = dataRectAlt.x;
                        dataCop.y = dataRectAlt.y;
                        dataCop.posX = dataRectAlt.posX;
                        dataCop.posY = dataRectAlt.posY;

                        this.createModule(dataCop).then(res => {
                            if (res) {
                                gContentModule.raise();
                                gContentModule.node().append(res.elt);
                                this.loadConfigModule(res.elt, res.module);
                                this.addGroupAuto(res.elt, groupId);
                                this.loadListnerModule(res.elt);
                                // this.drag(d3.select(res.elt), this.dragStartSVG, this.dragSVG, this.dragEndSVG)
                                d3.select("#meubleInt")
                                    .selectAll("rect.accessory-frame")
                                    .raise();
                                return true;
                            } else {
                                return false;
                            } //
                        });
                    });
                    // let modD3
                    // modules.each((data1, i, cmps) => {
                    //     let dataCop = this.assign(data1)
                    //     uuidMod = 'elt_' + this.UUID()
                    //
                    //     let resX = dataCop.posX
                    //     let resY = dataCop.posY
                    //     posX = resX + dataRect.posX
                    //     posY = resY + dataRect.posY
                    //     dataCop.groupId = null
                    //     dataCop.selected = false
                    //     dataCop.UUID = uuidMod
                    //     rectAlt = this.getRectByPosition(posX, posY)
                    //     dataRectAlt = d3.select(rectAlt).data()[0]
                    //
                    //     dataCop.x = dataRectAlt.x
                    //     dataCop.y = dataRectAlt.y
                    //     dataCop.posX = dataRectAlt.posX
                    //     dataCop.posY = dataRectAlt.posY
                    //
                    //     this.createModule(dataCop).then((res) => {
                    //         if (res) {
                    //             gContentModule.raise()
                    //             gContentModule.node().append(res.elt)
                    //             this.loadConfigModule(res.elt, res.module)
                    //             this.addGroupAuto(res.elt, groupId)
                    //             this.loadListnerModule(res.elt)
                    //             // this.drag(d3.select(res.elt), this.dragStartSVG, this.dragSVG, this.dragEndSVG)
                    //             d3.select('#meubleInt').selectAll('rect.accessory-frame').raise()
                    //             return true
                    //         } else {
                    //             return false
                    //         }//
                    //     })
                    //
                    // })

                    if (objectScratchpad.isScratchpad === true) {
                        objectScratchpad.svg.parentNode.removeChild(objectScratchpad.svg);
                        this.deleteScratchModule(objectScratchpad);
                    }
                    this.setUpdatePlano(false);
                }
            }
            d3.select(svg).remove();
        },
        dragStartSVG(d, i, cmps) {
            let img = cmps[i];
            let rect = this.getRectByPos(d3.event.sourceEvent.pageX, d3.event.sourceEvent.pageY);
            if (!rect) return;
            let dataRect = d3.select(rect).data()[0];
            let posXOrigin = d.posX - dataRect.posX;
            let posYOrigin = d.posY - dataRect.posY;
            let origin = { posX: posXOrigin, posY: posYOrigin };
            d.posInit = origin;
            // .classed('dragging', true)
            let g = cmps[i].parentNode;
            let gD3 = d3.select(g);
            gD3.raise();
            gD3.select(".group-selected").attr("visibility", "hidden");

            d3.select(img)
                .attr("x", (data, i, cmps) => {
                    return data.x;
                })
                .attr("y", data => {
                    return data.y;
                });
        },
        dragSVG(data, i, cmps) {
            let tailleX = 20;
            let tailleY = 20;
            let img = cmps[i];

            let x = 0;
            let y = 0;
            let container = d3.select("#meubleInt");
            let bb = container.node().getBBox();
            //
            let bbx = bb.x;
            let bby = bb.y;
            let w = bb.width + bbx;
            let h = bb.height + bby;

            x = d3.event.x;
            y = d3.event.y;

            let gridX;
            let gridY;
            let posXOrigin = data.posX;
            let posYOrigin = data.posY;
            let modules = d3.select(img.parentNode).selectAll(".module_snap");

            modules
                .attr("x", (d, i, cmps) => {
                    let cmp = cmps[i];
                    let width = parseFloat(cmp.getAttribute("width")) / d.size.width;
                    let res = d.posX - posXOrigin;

                    gridX = x + res * width;

                    gridX = this.round(Math.max(bbx, Math.min(w, gridX)), tailleX);
                    return gridX;
                })
                .attr("y", (d, i, cmps) => {
                    let cmp = cmps[i];
                    let height = parseFloat(cmp.getAttribute("height")) / d.size.height;
                    let res = d.posY - posYOrigin;

                    gridY = y + res * height;
                    gridY = this.round(Math.max(bby, Math.min(h, gridY)), tailleY);
                    return gridY;
                });
        },
        dragEndSVG(d, i, cmps) {
            if (d.type === "module" || d.type === undefined) {
                this.selectionModule(d, i, cmps);
            }
            let img = cmps[i];
            let posXOrigin = d.posX - d.posInit.posX;
            let posYOrigin = d.posY - d.posInit.posY;
            let gD3 = d3.select(img.parentNode);

            let modules = gD3.selectAll(".module_snap");
            let rect = this.getRectByPos(d3.event.sourceEvent.pageX, d3.event.sourceEvent.pageY);

            let valid = true;
            if (rect !== null) {
                let dataRect = d3.select(rect).data()[0];
                let posX;
                let posY;
                let rectAlt;
                let mod;
                let dataRectAlt;
                modules.each((d, i, cmps) => {
                    if (valid === false) return false;
                    mod = cmps[i];
                    let resX = d.posX - posXOrigin;
                    let resY = d.posY - posYOrigin;
                    posX = resX + dataRect.posX;
                    posY = resY + dataRect.posY;
                    rectAlt = this.getRectByPosition(posX, posY);
                    // console.log(posX, posY)
                    dataRectAlt = d3.select(rectAlt).data()[0];

                    // console.log(this.hasModuleOutAtPos(posX, posY, d), '=== out ===')

                    // console.log(rectAlt)
                    if (this.hasModuleOutAtPos(posX, posY, d)) {
                        this.$swal({
                            title: this.$t("planobuilder.warning"),
                            text: this.$t("planobuilder.messageAlert3"),
                            type: "warning",
                            //                                showCancelButton: true,
                            confirmButtonColor: "#41b4e8",
                            confirmButtonText: "Ok"
                            // cancelButtonText: 'Non'
                        });
                        valid = false;
                        return false;
                    } else if (this.hasModuleAtPos(posX, posY, d)) {
                        this.$swal({
                            title: this.$t("planobuilder.warning"),
                            text: this.$t("planobuilder.messageAlert2"),
                            type: "warning",
                            //                                showCancelButton: true,
                            confirmButtonColor: "#41b4e8",
                            confirmButtonText: "Ok"
                            // cancelButtonText: 'Non'
                        });
                        valid = false;
                        return false;
                    }
                });

                if (valid) {
                    let posXMin = null;
                    let posYMin = null;
                    modules.each((d, i, cmps) => {
                        mod = cmps[i];
                        let resX = d.posX - posXOrigin;
                        let resY = d.posY - posYOrigin;
                        posX = resX + dataRect.posX;
                        posY = resY + dataRect.posY;
                        rectAlt = this.getRectByPosition(posX, posY);
                        dataRectAlt = d3.select(rectAlt).data()[0];
                        d3.select(mod)
                            .attr("x", d => {
                                d.x = dataRectAlt.x;
                                d.posX = dataRectAlt.posX;
                                if (posXMin === null) {
                                    posXMin = dataRectAlt.x;
                                } else if (posXMin > dataRectAlt.x) {
                                    posXMin = dataRectAlt.x;
                                }
                                return d.x;
                            })
                            .attr("y", d => {
                                d.y = dataRectAlt.y;
                                d.posY = dataRectAlt.posY;

                                if (posYMin === null) {
                                    posYMin = dataRectAlt.y;
                                } else if (posYMin > dataRectAlt.y) {
                                    posYMin = dataRectAlt.y;
                                }
                                return d.y;
                            });
                    });

                    if (posXOrigin !== dataRect.posX || posYOrigin !== dataRect.posY) {
                        this.setUpdatePlano(false);
                    }

                    gD3.select("rect.group-selected")
                        .attr("visibility", "visible")
                        .attr("x", posXMin)
                        .attr("y", posYMin);
                }
            } else {
                valid = false;
            }

            if (!valid) {
                // alert('On ne peut pas mettre un module a cette position elle est déjà occupé')
                let x = 0;
                let y = 0;
                modules
                    .attr("x", (d, i) => {
                        if (i === 0) {
                            x = d.x;
                        } else if (x > d.x) {
                            x = d.x;
                        }
                        return d.x;
                    })
                    .attr("y", (d, i) => {
                        if (i === 0) {
                            y = d.y;
                        } else if (y > d.y) {
                            y = d.y;
                        }
                        return d.y;
                    });

                gD3.select("rect.group-selected")
                    .attr("visibility", "visible")
                    .attr("x", x)
                    .attr("y", y);
            }
            d3.select("#meubleInt")
                .selectAll("rect.accessory-frame")
                .raise();
        },
        clickSelectionAccessory(d, i, cmps) {
            if (this.modeSelection) {
                this.deselectAll();
                let selected = !d.selected;
                this.selectedAccessory(d, selected);
            }
        },
        selectedAccessory(d, selected) {
            let accessoryD3 = d3.select("rect#" + d.UUID);
            if (selected) {
                this.addAccessorySelected(d);
                accessoryD3.attr("stroke", "#41B4E8");
            } else {
                this.deleteAccessorySelected(d);
                accessoryD3.attr("stroke", d.color);
            }
            d.selected = selected;
        },
        selectionModule(d, i, cmps) {
            if (d3.event.defaultPrevented) return;
            let single = this.singleSelection;
            if (single) {
                this.deselectAll();
            }

            let gElt = cmps[i].parentNode;
            let gEltD3 = d3.select(gElt);
            if (this.modeSelection) {
                let selected = !d.selected;
                let group = this.getGroupById(d.groupId);
                let modules = group.modules;
                if (modules.length > 1) {
                    this.deselectAll();
                    this.groupSelected = selected ? group : null;
                }
                d.selected = selected;
                let elt;
                let bb = gElt.getBBox();

                let rectD3 = gEltD3.select("rect.group-selected");
                if (selected && rectD3.size() === 0) {
                    rectD3 = gEltD3
                        .append("rect")
                        .lower()
                        .attr("class", "group-selected")
                        .attr("stroke", "#41B4E8")
                        .attr("stroke-width", "15")
                        .attr("fill", "#41B4E8")
                        .attr("fill-opacity", 0)
                        .attr("width", bb.width)
                        .attr("height", bb.height)
                        .attr("x", bb.x)
                        .attr("y", bb.y);
                }

                if (selected) {
                    rectD3.attr("visibility", "visible");
                } else {
                    rectD3.remove();
                }

                modules.forEach(mod => {
                    mod.selected = true;
                    elt = d3.select("#" + mod.UUID).node();
                    if (selected) {
                        mod.selected = true;
                        this.addSelectModule(elt);
                    } else {
                        mod.selected = false;
                        this.deleteSelectModule(elt);
                    }
                });
            }
        },
        deselectAll() {
            this.groupSelected = null;
            d3.selectAll("rect.group-selected").remove();

            d3.select("#meubleInt")
                .selectAll(".module_snap")
                .each((d, i, cmps) => {
                    d.selected = false;
                    let elt = cmps[i];
                    let g = elt.parentNode;
                    let data = d3.select(g).data()[0];
                    if (data) data.selected = false;
                });
            this.cleanSelectedModules();
            let accessoriesSeleced = this.getAccessoriesSelected;
            let accessories = [];
            accessoriesSeleced.forEach(accessory => {
                accessories.push(accessory);
            });

            accessories.forEach(accessory => {
                this.selectedAccessory(accessory, false);
            });
        },
        getGroupByModule(module) {
            let groups = this.groups;
            let modules;
            let group;
            let mod;
            let groupSelect = null;
            for (let i = 0; i < groups.length; i++) {
                group = groups[i];
                modules = group.modules;

                for (let j = 0; j < modules.length; j++) {
                    mod = modules[j];
                    if (mod.groupId === module.groupId) {
                        groupSelect = group;
                        break;
                    }
                }

                if (groupSelect !== null) break;
            }
            return groupSelect;
        },
        destroyMenu(className = null) {
            d3.select("div.content-menu-item").remove();
            d3.select("div.content-menu").remove();
            d3.select("div.content-menu-hide").remove();
        },
        createMenu(items, menuItem = false, menuHide = false, event = null) {
            // console.log(i18n.locale)
            event = event === null ? d3.event : event;
            let x = event.clientX;
            let y = event.clientY;
            // console.log(event)
            d3.select("div.content-menu-item").remove();
            if (menuItem === false) {
                d3.select("div.content-menu").remove();
            }

            let contentMenu = document.createElement("div");
            //                contentMenu.id = id
            let className = menuItem ? "content-menu content-menu-item" : "content-menu";
            if (menuHide) {
                className = "content-menu-hide";
            }

            contentMenu.className = className;
            contentMenu.style.left = x + "px";
            contentMenu.style.top = y + "px";
            let addclass = "";
            items.forEach(item => {
                let itemElt = document.createElement("div");
                if (menuHide) {
                    let iELt = document.createElement("span");
                    iELt.classList.add("layer-icon", "layer-icon-hidden");
                    iELt.id = "layer-icon-" + item.id;
                    // iELt.className = 'layer-icon'
                    // iELt.style.backgroundImage = 'url("../../assets/eye.svg")'
                    // iELt.style.height = '16px'
                    // iELt.style.width = '16px'
                    itemElt.appendChild(iELt);
                    // itemElt.appendChild('i');
                }
                if (item.addClass) {
                    addclass = " " + item.addClass;
                }
                itemElt.className = (menuItem ? "parent-item-menu menu-item" : "menu-item") + addclass;
                let label = "";
                // console.log(item.label, item.label instanceof String, '====  label ========')
                if (item.label instanceof Object) {
                    // console.log('object')
                    label = item.label[i18n.locale];
                } else {
                    // console.log('string')
                    label = this.$t(item.label);
                }

                itemElt.appendChild(document.createTextNode(label));
                contentMenu.appendChild(itemElt);
                let args = null;
                let event = item.event === undefined ? "click" : item.event;
                d3.select(itemElt).on("mouseover", (d, i, cmps) => {
                    if (!d3.event.target.className.includes("parent-item-menu")) {
                        d3.select("div.content-menu-item").remove();
                    }
                });
                d3.select(itemElt).on(event, e => {
                    args = item.args === undefined ? null : item.args;
                    if (args !== null) item.action.apply(this, args);
                    else item.action.apply(this, args);
                });
            });

            document.body.appendChild(contentMenu);

            d3.select("body").on("click", () => {
                if (menuHide === true) {
                    if (this.tabhide === false) d3.selectAll("div.content-menu-hide").remove();
                } else {
                    d3.selectAll("div.content-menu").remove();
                }
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/plano/mixins/plano.js